import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { COMPANY, ACCREDITATIONS } from "@/data/mock";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-brand-bg" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={COMPANY.logo}
              alt="NBB — Neighbours Brick & Build logo"
              className="w-12 h-12 rounded-full object-cover ring-1 ring-white/10"
            />
            <div className="font-display">
              <div className="text-lg font-semibold leading-none">Neighbours</div>
              <div className="text-[11px] tracking-[0.2em] uppercase text-brand-bg/60">
                Brick &amp; Build
              </div>
            </div>
          </div>
          <p className="mt-6 text-brand-bg/70 max-w-md leading-relaxed">
            A small Berkshire builder doing careful work for the people who live next door. Brickwork,
            extensions, refurbs &amp; new builds — done properly, on time, on budget.
          </p>
          <div className="mt-6 flex flex-wrap gap-2 hidden">
            {ACCREDITATIONS.map((a) => (
              <span
                key={a}
                className="text-xs uppercase tracking-wider px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-brand-bg/80"
              >
                {a}
              </span>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-bg/50 mb-4">Sitemap</h4>
          <ul className="space-y-3 text-brand-bg/80">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/projects" className="hover:text-white">Projects</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/testimonials" className="hover:text-white">Reviews</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-bg/50 mb-4">Visit / call</h4>
          <ul className="space-y-3 text-brand-bg/80">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-brand-ochre" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-brand-ochre" />
              <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-white">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-brand-ochre" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a>
            </li>
            <li className="text-brand-bg/60 text-sm">{COMPANY.hours}</li>
          </ul>
          <div className="mt-6 flex items-center gap-3">
            <a href={COMPANY.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 inline-flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 border border-white/10">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-center justify-between gap-3 text-sm text-brand-bg/50">
          <p>© {new Date().getFullYear()} {COMPANY.name}. Registered in England &amp; Wales.</p>
          <p className="font-display tracking-tight">{COMPANY.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
